


























































































































































































































































































import { Component, Prop, Watch } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import BaseTab from './baseTab'
import { ExStore } from 'vuex'
import dayjs from 'dayjs'
import { Vitalsign } from '@/types/vitalsign'
import { DateString } from '@/types/utils'
import { VitalsignPayload } from '@/api/vitalsign/types'
import { VitalsignSetting } from '@/types/vitalsign'
import ky from 'ky'

const DATE_FORMAT = 'YYYY-MM-DD HH:mm'
const YEAR_RANGE = 3
const C_RED = 'red'
const C_BLUE = 'blue'

@Component({
  filters: {
    formatDate(date: string) {
      return dayjs(date).format('M/D')
    },
    formatTime(date: string) {
      return dayjs(date).format('HH:mm')
    },
    formatFloat(num: number, digits: number) {
      if (!num) return '-'
      return Number(num).toFixed(digits)
    },
    formatVitalsignValue(value: number | null, type: string): string | number {
      if (type == 'glucose') {
        if (value && value >= 601) return 'High'
        if (value && value <= 19) return 'Low'
      }
      if (type === 'temperature' && value) {
        return value.toFixed(1)
      }
      return value ? value : '-'
    }
  },
  components: {
    VitalsignSetting: () =>
      import('@/components/vitalsign/VitalsignSetting.vue'),
    FlushMessage: () => import('@/components/common/FlushMessage.vue')
  }
})
export default class VitalsignTab extends mixins(BaseTab) {
  @Prop({ default: null, type: Number }) year!: number | null
  @Prop({ default: null, type: Number }) month!: number | null
  @Prop({ default: null, type: Number }) day!: number | null
  @Prop({ default: 'week', type: String }) span!: string | null
  @Prop({ default: 'true', type: String }) before!: string
  @Prop(Number) patientId!: number
  $store!: ExStore
  vitals: Vitalsign[] = []
  manualVital: VitalsignPayload = {}
  changedVitals: number[] = []
  customItemNames: string[] = []
  settingVisible = false
  settings: Partial<VitalsignSetting> = {}
  labels = [
    {
      label: 'SpO2',
      prop: 'spo2',
      settingProp: 'Spo2'
    },
    {
      label: '血圧（上）',
      prop: 'sbp',
      settingProp: 'Sbp'
    },
    {
      label: '血圧（下）',
      prop: 'dbp',
      settingProp: 'Dbp'
    },
    {
      label: '脈拍数',
      prop: 'pulseRate',
      settingProp: 'PulseRate'
    },
    {
      label: '心拍数',
      prop: 'heartRate',
      settingProp: 'HeartRate'
    },
    {
      label: '体温',
      prop: 'temperature',
      settingProp: 'Temperature'
    },
    {
      label: '体重',
      prop: 'weight',
      settingProp: 'Weight'
    },
    {
      label: '血糖値',
      prop: 'glucose',
      settingProp: 'Glucose'
    }
  ]

  get manualVitalPayload() {
    const payload = Object.assign({}, this.manualVital)
    if (!payload.item1Value) delete payload.item1Name
    if (!payload.item2Value) delete payload.item2Name
    if (!payload.item3Value) delete payload.item3Name
    if (!payload.item4Value) delete payload.item4Name
    if (!payload.item5Value) delete payload.item5Name
    Object.entries(payload).map(([key, val]) => {
      if (val === '') delete payload[key as keyof VitalsignPayload]
    })
    return payload
  }

  get hasMaxCustomArea() {
    return this.customItemNames.length >= 5
  }

  get selectedMonthForInput() {
    const date = dayjs(this.manualVital.measureDatetime)
    return date.month()
  }

  set selectedMonthForInput(month) {
    const date = dayjs(this.manualVital.measureDatetime).month(month)
    this.$set(this.manualVital, 'measureDatetime', date.format(DATE_FORMAT))
  }

  get selectedDayForInput() {
    const date = dayjs(this.manualVital.measureDatetime)
    return date.date()
  }

  set selectedDayForInput(day) {
    const date = dayjs(this.manualVital.measureDatetime).date(day)
    this.$set(this.manualVital, 'measureDatetime', date.format(DATE_FORMAT))
  }

  get selectedHourForInput() {
    const date = dayjs(this.manualVital.measureDatetime)
    return date.hour()
  }

  set selectedHourForInput(hour) {
    const date = dayjs(this.manualVital.measureDatetime).hour(hour)
    this.$set(this.manualVital, 'measureDatetime', date.format(DATE_FORMAT))
  }

  get selectedMinuteForInput() {
    const date = dayjs(this.manualVital.measureDatetime)
    return date.minute()
  }

  set selectedMinuteForInput(minute) {
    const date = dayjs(this.manualVital.measureDatetime).minute(minute)
    this.$set(this.manualVital, 'measureDatetime', date.format(DATE_FORMAT))
  }

  get selectedYear() {
    return this.year || dayjs().year()
  }

  set selectedYear(year) {
    this.setRoute({ year })
  }

  get selectedMonth() {
    return typeof this.month == 'number' ? this.month : dayjs().month()
  }

  set selectedMonth(month) {
    this.setRoute({ month })
  }

  get selectedDay() {
    return this.day || dayjs().date()
  }

  set selectedDay(day) {
    this.setRoute({ day })
  }

  get selectedSpan() {
    return this.span || 'week'
  }

  set selectedSpan(span) {
    this.setRoute({ span })
  }

  get isBefore() {
    return this.before || 'true'
  }

  set isBefore(before) {
    this.setRoute({ before })
  }

  get years() {
    return [...Array(YEAR_RANGE).keys()].map(i => dayjs().year() - i)
  }

  get months() {
    return [...Array(12).keys()]
  }

  get days() {
    const lastDay = dayjs()
      .year(this.selectedYear)
      .month(this.selectedMonth)
      .date(1)
      .add(1, 'month')
      .subtract(1, 'day')
      .date()
    return [...Array(lastDay).keys()].map(i => i + 1)
  }

  get daysForInput() {
    const lastDay = dayjs()
      .year(dayjs().year())
      .month(this.selectedMonthForInput)
      .date(1)
      .add(1, 'month')
      .subtract(1, 'day')
      .date()
    return [...Array(lastDay).keys()].map(i => i + 1)
  }

  get hours() {
    return [...Array(24).keys()]
  }

  get minutes() {
    return [...Array(60).keys()]
  }

  get avarages() {
    const sbp = this.vitals.filter(v => v.sbp != null)
    const dbp = this.vitals.filter(v => v.dbp != null)
    const heartRate = this.vitals.filter(v => v.heartRate != null)
    const temperature = this.vitals.filter(v => v.temperature != null)
    const pulseRate = this.vitals.filter(v => v.pulseRate != null)
    const weight = this.vitals.filter(v => v.weight != null)
    const spo2 = this.vitals.filter(v => v.spo2 != null)
    const glucose = this.vitals.filter(v => v.glucose != null)
    return {
      sbp: sbp.reduce((a, b) => a + b.sbp, 0) / sbp.length,
      dbp: dbp.reduce((a, b) => a + b.dbp, 0) / dbp.length,
      heartRate:
        heartRate.reduce((a, b) => a + b.heartRate, 0) / heartRate.length,
      temperature:
        temperature.reduce((a, b) => a + b.temperature, 0) / temperature.length,
      pulseRate:
        pulseRate.reduce((a, b) => a + b.pulseRate, 0) / pulseRate.length,
      spo2: spo2.reduce((a, b) => a + b.spo2, 0) / spo2.length,
      weight: weight.reduce((a, b) => a + b.weight, 0) / weight.length,
      glucose: glucose.reduce((a, b) => a + b.glucose, 0) / glucose.length
    }
  }

  @Watch('$route')
  async onRouteChange() {
    await this.getSetting()
    await this.getVitalsign()
    this.resetDatatableScroll()
  }

  async created() {
    this.manualVital = { measureDatetime: dayjs().format(DATE_FORMAT) }
    await this.getSetting()
    await this.getVitalsign()
  }

  async getSetting() {
    const res = await this.$api.vitalsign.fetchSetting({
      patientId: this.patientId
    })
    this.settings = res
  }

  setRoute(payload: {
    year?: number
    month?: number
    day?: number
    span?: string
    before?: string
  }) {
    const q = Object.assign(
      {
        year: this.selectedYear,
        month: this.selectedMonth,
        day: this.selectedDay,
        span: this.selectedSpan,
        before: this.isBefore
      },
      payload
    )
    this.$router.push({
      name: 'VitalSignTab',
      query: {
        year: String(q.year),
        month: String(q.month),
        day: String(q.day),
        span: q.span,
        before: q.before
      }
    })
  }

  getBeforeAndAfter() {
    const { selectedYear, selectedMonth, selectedDay } = this
    const isBefore = this.isBefore === 'true'
    const selectedDate = dayjs()
      .year(selectedYear)
      .month(selectedMonth)
      .date(selectedDay)
    const method = !isBefore ? 'add' : 'subtract'
    const daySpan = this.selectedSpan === 'week' ? 7 : 14
    const calucDate =
      this.selectedSpan === 'month'
        ? selectedDate[method](1, 'month')
        : selectedDate[method](daySpan, 'day')
    const before = !isBefore
      ? calucDate.add(1, 'day')
      : selectedDate.add(1, 'day')
    const after = isBefore ? calucDate.add(1, 'day') : selectedDate
    return {
      before: before.format('YYYY-MM-DD') as DateString,
      after: after.format('YYYY-MM-DD') as DateString
    }
  }

  async getVitalsign() {
    const { before, after } = this.getBeforeAndAfter()
    const res = await this.$api.vitalsign.fetch({
      patientId: this.patientId,
      before,
      after
    })
    this.vitals = res
    this.resetCustomItemNames()
  }

  async save() {
    await this.saveManualVital()
    await this.updateVitals()
  }

  async saveManualVital() {
    try {
      const payload = this.manualVitalPayload
      if (this.checkNullPayload(payload)) return
      const res = await this.$api.vitalsign.create({
        patientId: this.patientId,
        payload
      })
      const duplicated = this.vitals.filter(
        v => v.measureDatetime === res.measureDatetime
      )
      if (duplicated.length) {
        this.vitals = this.vitals.map(v => {
          if (v.measureDatetime === res.measureDatetime) {
            return Object.assign(v, res)
          } else {
            return v
          }
        })
      } else {
        this.vitals = [res, ...this.vitals]
      }
      this.resetDatatableScroll()
      this.resetManualVital()
    } catch (e) {
      if (e instanceof ky.HTTPError) {
        const errors = await e.response.json()
        this.$store.dispatch('alert/showErrorResponse', errors)
        return
      }
      console.error(e)
    }
  }

  async updateVitals() {
    await Promise.all(
      this.changedVitals.map(async id => {
        const vital = this.vitals.find(v => v.id === id)
        if (!vital) return
        const payload: VitalsignPayload = vital
        const res = await this.$api.vitalsign.patch({
          patientId: this.patientId,
          vitalsignId: vital.id,
          payload
        })
        this.updateLocalVital(res)
      })
    )
    this.changedVitals = []
  }

  checkNullPayload(payload: VitalsignPayload) {
    const obj = Object.assign({}, payload)
    delete obj.measureDatetime
    for (const [key, value] of Object.entries(obj)) {
      if (value) return false
    }
    return true
  }

  updateLocalVital(vital: Vitalsign) {
    const finded = this.vitals.find(v => v.id === vital.id)
    if (!finded) return
    const index = this.vitals.indexOf(finded)
    this.vitals.splice(index, 1, vital)
  }

  resetManualVital() {
    const names: string[] = [...Array(5)].map(() => '')
    for (let i = 0; i < names.length; i++) {
      const kValue = `item${i + 1}Value` as keyof VitalsignPayload
      if (this.manualVital[kValue]) {
        delete this.manualVital[kValue]
      }
    }
  }

  resetDatatableScroll() {
    const dataDom = document.getElementById('sapmle_test_wrapper')
    if (dataDom && 'scrollTo' in dataDom) {
      dataDom?.scrollTo(0, 0)
    } else {
      const elm: any = dataDom
      elm.scrollLeft = 0
    }
  }

  handleChangeVital(id: number, itemIndex: number) {
    type Names =
      | 'item1Name'
      | 'item2Name'
      | 'item3Name'
      | 'item4Name'
      | 'item5Name'
    const keys: Names[] = [
      'item1Name',
      'item2Name',
      'item3Name',
      'item4Name',
      'item5Name'
    ]
    const finded = this.vitals.find(v => v.id === id)
    if (!finded) return
    finded[keys[itemIndex]] = this.manualVital[keys[itemIndex]]
    this.updateLocalVital(finded)
    if (!(id in this.changedVitals)) this.changedVitals.push(id)
  }

  addCustomItemArea() {
    if (this.hasMaxCustomArea) return
    this.customItemNames = [...this.customItemNames, '']
  }

  resetCustomItemNames() {
    const sorted = this.vitals.slice().sort((a, b) => b.id - a.id)
    const names: string[] = [...Array(5)].map(() => '')
    for (let i = 0; i < names.length; i++) {
      const kName = `item${i + 1}Name` as keyof VitalsignPayload
      const kValue = `item${i + 1}Value` as keyof VitalsignPayload
      const finded = sorted.find(v => v[kValue])
      if (finded) {
        names[i] = String(finded[kName])
        this.$set(this.manualVital, kName, String(finded[kName]))
      }
    }
    for (let i = names.length - 1; i > 0; i--) {
      if (names[i]) break
      names.splice(i, 1)
    }
    this.customItemNames = names
  }

  getManualVital(key: keyof VitalsignPayload) {
    const value = this.manualVital[key]
    return !value || value === 'null' ? '' : this.manualVital[key]
  }

  setManualVital(key: keyof VitalsignPayload, value: string) {
    const _value = value ? value : ''
    this.$set(this.manualVital, key, _value)
  }

  getStatusColor(type: string, value: number) {
    if (type === 'Glucose') {
      if (value && value >= 601) return C_RED
      if (value && value <= 19) return C_BLUE
    }
    const { settings } = this
    const emg = {
      chk: `emgIsLimitchk${type}` as keyof VitalsignSetting,
      high: `emgLimit${type}High` as keyof VitalsignSetting,
      low: `emgLimit${type}Low` as keyof VitalsignSetting
    }
    const warn = {
      chk: `warnIsLimitchk${type}` as keyof VitalsignSetting,
      high: `warnLimit${type}High` as keyof VitalsignSetting,
      low: `warnLimit${type}Low` as keyof VitalsignSetting
    }
    if (settings[emg.chk]) {
      const high = settings[emg.high]
      const low = settings[emg.low]
      if (high && value > high) return C_RED
      if (low && value < low) return C_BLUE
    }
    if (settings[warn.chk]) {
      const high = settings[warn.high]
      const low = settings[warn.low]
      if (high && value > high) return C_RED
      if (low && value < low) return C_BLUE
    }
    return ''
  }

  getAlertClass(type: string, on: boolean) {
    return `${type} ${!on && 'inactive'}`
  }

  async handleCloseSetting() {
    this.settingVisible = false
    await this.getSetting()
    if (localStorage.getItem('message')) {
      const flushMessage: any = this.$refs.flushMessage
      flushMessage.open()
    }
  }
}
